import React from 'react';
import { TagsTable } from './TagsTable';
import WelcomeBannerHome from '../../Components/home/WelcomeBannerHome';
import SideBar from '../../Components/home/SideBar';
import { useGetTagByNameQuery } from '../../gql/generated';
import { CondorStandardTags } from '../../Components/manage-tags/CondorStandardTags';
import CondorSpinner from '../../Components/CondorSpinner';

export const ManageTagsPage = () => {
  const { data: purpleData, loading: purpleLoading } = useGetTagByNameQuery({
    fetchPolicy: 'no-cache',
    variables: {
      tagName: 'purple',
    },
  });

  const purpleDeviceTag = {
    tagId: purpleData?.getTagByName?.tagId ?? '',
    tagName: purpleData?.getTagByName?.tagName ?? '',
  };

  const { data: yellowData, loading: yellowLoading } = useGetTagByNameQuery({
    fetchPolicy: 'no-cache',
    variables: {
      tagName: 'yellow',
    },
  });

  const yellowDeviceTag = {
    tagId: yellowData?.getTagByName?.tagId ?? '',
    tagName: yellowData?.getTagByName?.tagName ?? '',
  };

  return (
    <div style={{ paddingBottom: '5%' }}>
      <WelcomeBannerHome subtitle="Let's manage some tags and stuff" />
      <div style={{ display: 'flex' }}>
        <div style={{ flexBasis: '20%' }}>
          <SideBar />
        </div>
        <div style={{ flexBasis: '80%' }}>
          {purpleLoading || yellowLoading ? (
            <CondorSpinner />
          ) : (
            <>
              <CondorStandardTags
                purpleTag={purpleDeviceTag}
                yellowTag={yellowDeviceTag}
              />
              <TagsTable
                purpleTag={purpleDeviceTag}
                yellowTag={yellowDeviceTag}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};
